// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Liechtenstein from '../_raw/flag/icon_flag_liechtenstein.png';

export default () => <img src={Liechtenstein} alt="Liechtenstein" />;
